<form (keyup.enter)="submit()" [formGroup]="form">
  <div class="input-row-name">
    <gl-input-container>
      <input formControlName="name" normal-input placeholder="name" type="text" data-ctx="input-name" />
    </gl-input-container>
  </div>
  <div class="dimensions">
    <div class="titlePart">
      <span>{{ 'pallet' | translate }}</span>
    </div>
    <div class="input-row">
      <gl-input-container [units]="'length'">
        <input
          [numericType]="'float'"
          formControlName="length"
          normal-input
          placeholder="length"
          type="text"
          />
      </gl-input-container>
      <gl-input-container [units]="'length'">
        <input
          [numericType]="'float'"
          formControlName="width"
          normal-input
          placeholder="width"
          type="text"
          />
      </gl-input-container>

      <gl-input-container [units]="'length'">
        <input
          [numericType]="'float'"
          formControlName="palletHeight"
          normal-input
          placeholder="height"
          type="text"
          />
      </gl-input-container>
    </div>
    <div class="input-row">
      <gl-input-container [glPremium]="true" [units]="'weight'">
        <input
          [numericType]="'float'"
          formControlName="palletWeight"
          normal-input
          placeholder="weight"
          type="text"
          />
      </gl-input-container>
      <gl-input-container [glPremium]="true" [units]="'weight'">
        <input
          [numericType]="'float'"
          formControlName="palletMaxCapacity"
          normal-input
          placeholder="max_capacity"
          type="text"
          />
      </gl-input-container>
      <gl-input-container [units]="'length'">
        <input
          [numericType]="'float'"
          formControlName="palletMaxHeight"
          normal-input
          placeholder="max_height"
          type="text"
        /></gl-input-container>
      </div>
      <div class="input-row right">
        <div></div>
        <div></div>
        @if (!changeType) {
          <gl-input-container>
            <input
              [numericType]="'float'"
              formControlName="palletQuantity"
              min="1"
              number-input
              placeholder="quantity"
              type="number"
              />
          </gl-input-container>
        }
      </div>
      @if (isEdit) {
        <div class="buttonRow">
          @if (changeType && !isLoadingSpaceEquel()) {
            <div class="saveInfo">
              {{ 'save_information' | translate }}
            </div>
          }
          @if (isFormChanged) {
            <form [formGroup]="saveLoadingForm">
              @if (!isMyLoadingSpace) {
                @if (isFormChanged && !isMyLoadingSpace) {
                  <gl-icon-checkbox
                    [checkboxFormGroup]="saveLoadingForm"
                    [tooltipInfo]="'save_info'"
                    [controlName]="'remember'"
                    [iconName]="'saveIcon'"
                  ></gl-icon-checkbox>
                }
              }
            </form>
          }
          <button
            data-ctx="button-submit"
            (click)="submit()"
            outline-button
            type="submit"
            [class.saveButton]="changeType && !isLoadingSpaceEquel()"
            >
            @if (isMyLoadingSpace || changeType) {
              {{ 'save' | translate }}
            }
            @if (!isMyLoadingSpace && !changeType) {
              {{ 'add' | translate }}
            }
          </button>
          @if (!hideDelete) {
            <button
              (click)="changeType ? emitDeleteLoadingSpace() : resetForm()"
              outline-icon-button
              type="reset"
              >
              <gl-icon name="delete"></gl-icon>
            </button>
          }
          <button (click)="reload()" outline-icon-button type="button">
            <gl-icon name="startArrangement"></gl-icon>
          </button>
        </div>
      }
    </div>
  </form>
